"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initShoppingContextEvents = initShoppingContextEvents;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var RequestShoppingContext = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var ShoppingContextLoaded = _interopRequireWildcard(require("@ori-events/shopping-context-loaded"));
var _ShoppingContextData = require("./ShoppingContextData");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
/** Global events needed for monitoring shopping context data. */
const shoppingContextEventNames = [BasketUpdated.Name, ShoppingContextLoaded.Name];

/** Indication that shopping context data was already received. */
let hasShoppingContextInfo = false;
function pushShoppingContextData(event, tagManagementHandler) {
  // mark the shopping context data as loaded
  hasShoppingContextInfo = true;

  // create analytics event in same format as AnalyticsEvent.forwardAnalyticsEvent would return
  const {
    availableRewardShopPoints: points
  } = event.detail.shoppingBag;
  const rewardPoints = typeof points === 'number' ? points : null;

  // forward the event to defined analytics channels
  tagManagementHandler(_ShoppingContextData.ShoppingContextDataEvent, {
    rewardPoints
  });
}

/**
 * @deprecated Replace with an integration event with proper context data.
 *
 * Connects listening to first incoming shopping context data event
 * (shopping-context-loaded or basket-updated). Once received, forwards
 * selected event data to dataLayer & disconnects both events.
 */
function initShoppingContextEvents(tagManagementHandler) {
  const handler = event => {
    pushShoppingContextData(event, tagManagementHandler);
    // disconnect events after 1st shopping context info was received
    shoppingContextEventNames.forEach(eventName => window.removeEventListener(eventName, handler));
  };
  shoppingContextEventNames.forEach(eventName => window.addEventListener(eventName, handler));

  // Only if the shopping context data wasn't loaded in a half second
  // due to events triggered by other components, trigger the request context event here.
  window.setTimeout(() => {
    if (!hasShoppingContextInfo) {
      window.dispatchEvent(new CustomEvent(RequestShoppingContext.Name));
    }
  }, 500);
}